export default function getGapX(value) {
  switch (value) {
    case 0.5:
      return "gap-x-0.5";
    case 1:
      return "gap-x-1";
    case 2:
      return "gap-x-2";
    case 3:
      return "gap-x-3";
    case 4:
      return "gap-x-4";
    case 5:
      return "gap-x-5";
    case 6:
      return "gap-x-6";
    case 7:
      return "gap-x-7";
    case 8:
      return "gap-x-8";
    case 9:
      return "gap-x-9";
    case 10:
      return "gap-x-10";
    case 12:
      return "gap-x-12";
    case 14:
      return "gap-x-14";
    case 16:
      return "gap-x-16";
    case 20:
      return "gap-x-20";
    case 24:
      return "gap-x-24";
    case 28:
      return "gap-x-28";
    case 32:
      return "gap-x-32";
    case 36:
      return "gap-x-36";
    case 40:
      return "gap-x-40";
    case 44:
      return "gap-x-44";
  }
}
